import React from 'react'

import { OnlineOrderingProviders } from 'src/public/components/online_ordering/OnlineOrderingProviders'
import { Channel } from 'src/public/js/siteUtilities'

type Props = {
  channel: Channel
}

export const OrderPageContexts = ({
  children,
  channel
}: React.PropsWithChildren<Props>) => {
  return (
    <OnlineOrderingProviders
      channel={channel}
      isOrderPage={channel === Channel.OO}
    >
      {children}
    </OnlineOrderingProviders>
  )
}
